export const STATUS_META = {
  kontakt_nu: { label: "Kontakt nu", tone: "positive", priority: 0 },
  bekræft_ledighed: {
    label: "Bekræft ledighed",
    tone: "attention",
    priority: 1,
  },
  budgetrisiko: { label: "Budgetrisiko", tone: "risk", priority: 2 },
  ventekandidat: { label: "Ventekandidat", tone: "neutral", priority: 3 },
  udlejet: { label: "Udlejet", tone: "muted", priority: 4 },
} as const;

export type CandidateStatus = keyof typeof STATUS_META;
export type SortOrder = "priority" | "likes" | "price" | "rooms" | "area";

export interface PublicUser {
  username: "mikkel" | "lisa" | "rebecca";
  displayName: string;
  color: string;
}

export interface CandidateComment {
  id: string;
  candidateId: string;
  user: PublicUser;
  body: string;
  createdAt: string;
  canDelete: boolean;
}

export interface CandidateEngagement {
  hearts: PublicUser[];
  comments: CandidateComment[];
}

export interface BriefMedia {
  src: string;
  alt: string;
}

export interface CandidateBrief {
  checkedAt: string;
  availability: "active" | "unverified" | "planned" | "rented";
  summary: string;
  description: string;
  facts: string[];
  considerations: string[];
  photos: BriefMedia[];
  floorPlans: BriefMedia[];
  mediaCaveat: string;
  sourceNote: string;
  contact?: {
    name: string;
    phone?: string;
    email?: string;
  };
}

export interface Candidate {
  id: string;
  sourceOrder: number;
  status: CandidateStatus;
  address: string;
  postalCode: string;
  city: string;
  source: string;
  url: string;
  propertyType: string;
  rooms: number;
  areaM2: number;
  rent: number;
  utilities: number | null;
  monthlyTotal: number | null;
  moveInTotal: number | null;
  availableFrom: string;
  tenancy: string;
  furnished: string;
  pros: string[];
  risks: string[];
  nextAction: string;
  brief: CandidateBrief;
  location: {
    lat: number;
    lng: number;
    precision: "exact" | "street" | "area";
  };
  engagement: CandidateEngagement;
}

export function filterAndSortCandidates(
  candidates: Candidate[],
  status: CandidateStatus | "all",
  sortOrder: SortOrder,
): Candidate[] {
  const filtered =
    status === "all"
      ? [...candidates]
      : candidates.filter((candidate) => candidate.status === status);

  return filtered.sort((left, right) => {
    if (sortOrder === "price") return left.rent - right.rent;
    if (sortOrder === "likes") {
      return right.engagement.hearts.length - left.engagement.hearts.length || left.sourceOrder - right.sourceOrder;
    }
    if (sortOrder === "rooms") return right.rooms - left.rooms;
    if (sortOrder === "area") return right.areaM2 - left.areaM2;

    return (
      STATUS_META[left.status].priority - STATUS_META[right.status].priority ||
      left.sourceOrder - right.sourceOrder
    );
  });
}
